// extracted by mini-css-extract-plugin
export var border = "_n-7";
export var brand = "_n-s";
export var button = "_n-k";
export var center = "_n-9";
export var centered = "_n-5";
export var closeButton = "_n-b";
export var disabledWrapper = "_n-l";
export var error = "_n-o";
export var extraLarge = "_n-4";
export var extraSmall = "_n-1";
export var fill = "_n-h";
export var footer = "_n-g";
export var footerAction = "_n-i";
export var footerButtons = "_n-j";
export var header = "_n-6";
export var headerWithClose = "_n-c";
export var icon = "_n-n";
export var info = "_n-r";
export var inline = "_n-8";
export var large = "_n-3";
export var main = "_n-d";
export var modal = "_n-0";
export var neutral = "_n-t";
export var noPadding = "_n-f";
export var none = "_n-u";
export var scrollable = "_n-e";
export var small = "_n-2";
export var success = "_n-q";
export var tight = "_n-m";
export var titleIcon = "_n-a";
export var warn = "_n-p";